import Store from '@/stores/store'
import Query from '@/services/query'
import { VUE_APP_ROOT_API } from '@/helpers/env'

export default {
  isConnected() {
    if (Store !== null) {
      return Store.getters.isConnected
    }
    return false
  },
  getAccessToken() {
    if (Store !== null) {
      return Store.getters.getAccessToken
    }
    return ''
  },
  getRefreshToken() {
    if (Store !== null) {
      return Store.getters.getRefreshToken
    }
    return ''
  },
  setLocalUser(isConnected, type, accessToken, refreshToken) {
    Store.commit('setUser', { isConnected, type, accessToken, refreshToken })
  },
  getLocalUser() {
    if (Store !== null) {
      return Store.getters.getUser
    }
    return {}
  },
  createUserAccount: async function(name, email, phoneNumber, password, heardAbout) {
    const response = await Query.post(`${VUE_APP_ROOT_API}/userapi/createuser`, JSON.stringify({ name, email, phoneNumber, password, heardAbout }))
    return response
  },
  completeUserRegistration: async function(email, token) {
    const response = await Query.post(`${VUE_APP_ROOT_API}/userapi/completeuserregistration`, JSON.stringify({ email, inviteToken: token }))
    return response
  },
  sendPasswordReset: async function(email) {
    const response = await Query.post(`${VUE_APP_ROOT_API}/userapi/sendpasswordreset`, JSON.stringify({ email }))
    return response
  },
  resetPassword: async function(email, password, token) {
    const response = await Query.post(`${VUE_APP_ROOT_API}/userapi/resetpassword`, JSON.stringify({ email, token, password }))
    return response
  },
  editMyInformation: async function(phoneNumber, currentPassword, newPassword) {
    const response = await Query.post(`${VUE_APP_ROOT_API}/userapi/edituserinformations`, JSON.stringify({ phoneNumber, currentPassword, newPassword }))
    return response
  },
  getMyInformations: async function() {
    const response = await Query.post(`${VUE_APP_ROOT_API}/userapi/getme`)
    return await response.json()
  },
  hasPhoneNumber: async function() {
    if (Store !== null) {
      var hasPhoneNumber =  Store.getters.hasPhoneNumber
      if(hasPhoneNumber !== null) {
        return hasPhoneNumber;
      }
      else if(Store.getters.isConnected) {
        const userInformation = await this.getMyInformations()
        hasPhoneNumber = Boolean(userInformation.PhoneNumber);
        this.setHasPhoneNumber(hasPhoneNumber);
        return hasPhoneNumber
      }
      else {
        return true;
      }
    }
    return true
  },
  setHasPhoneNumber: function(hasPhoneNumber) {
    Store.commit('setHasPhoneNumber', hasPhoneNumber)
  },
  getUserByIds: async function(ids) {
    const response = await Query.post(`${VUE_APP_ROOT_API}/userapi/getuserbyids`, JSON.stringify({ ids }))
    return await response.json()
  },
  manuallyActivateUser: async function(emailAddress) {
    const response = await Query.post(`${VUE_APP_ROOT_API}/userapi/manuallyActivateUser`, JSON.stringify({ emailAddress }))
    return await response.json()
  }
}
